import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-files-oauth-embeddable-confirm",
	templateUrl: "./files-oauth-embeddable-confirm.component.html",
	styleUrls: ["./files-oauth-confirm.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule],
})
export class FilesOAuthEmbeddableConfirmComponent {
	readonly authUrl = input.required<string>();

	readonly cmsTypeMessageKey = input.required<string>();

	readonly closeCallback = input.required<() => void>();

	close(): void {
		this.closeCallback()();
	}

	submit(): void {
		window.location.href = this.authUrl();
	}
}
